import { useTextes } from '../LangueContexte'
import { Bandeau } from './Champs'

/**
 * Informations légales — ticket `fo-transverse-07`.
 *
 * **Une page et non trois.** Conditions générales, politique de confidentialité et mentions légales
 * sont trois documents distincts en droit, mais ils se consultent au même moment et pour la même
 * raison : savoir à qui l'on a affaire. Trois pages quasi vides se seraient regardées l'une
 * l'autre ; trois sections ancrées se lisent d'une traite et se lient séparément depuis le pied de
 * page.
 *
 * **Ce que cette page ne fait pas, et pourquoi.** Elle n'invente aucun texte juridique. La raison
 * sociale de l'éditeur, l'adresse du siège, le directeur de publication, l'hébergeur et le numéro
 * de récépissé CNDP sont des faits que seul l'éditeur détient — les remplir « en attendant »
 * produirait un document faux qui a l'air vrai, et c'est précisément ce qu'un utilisateur vient
 * vérifier ici. Chaque section porte donc la liste de ce qu'il reste à fournir, ce qui en fait
 * une checklist plutôt qu'un trou.
 *
 * **La déclaration CNDP n'est pas optionnelle.** Le traitement de données personnelles est soumis
 * à la loi 09-08 ; la déclaration doit être faite avant l'ouverture au public, et son numéro
 * figurer ici. C'est une condition d'ouverture au même titre que la vérification des contacts
 * (D22), pas une formalité de fin de projet.
 */
export function InformationsLegales() {
  const t = useTextes()

  return (
    <section className="legal">
      <div className="page-entete">
        <h1>{t.legalTitre}</h1>
        <p>{t.legalIntro}</p>
      </div>

      <Bandeau ton="info">{t.legalAvantOuverture}</Bandeau>

      <section className="bloc" id="conditions">
        <h2>{t.legalConditions}</h2>
        <p className="secondaire">{t.legalConditionsResume}</p>
        <p className="tertiaire">{t.legalAFournir}</p>
      </section>

      <section className="bloc" id="confidentialite">
        <h2>{t.legalConfidentialite}</h2>
        <p className="secondaire">{t.legalConfidentialiteResume}</p>
        <p className="tertiaire">{t.legalAFournirConfidentialite}</p>
      </section>

      <section className="bloc" id="mentions">
        <h2>{t.legalMentions}</h2>
        <p className="secondaire">{t.legalMentionsResume}</p>
        <p className="tertiaire">{t.legalAFournirMentions}</p>
      </section>
    </section>
  )
}
